<nav class="navbar has-shadow" role="navigation" aria-label="main navigation">
  <div class="navbar-brand is-hidden-widescreen-only">
    <a class="navbar-item">
      <img height="50" [src]="logoUrl()" />
    </a>
  </div>

  <div class="navbar-menu">
    <div class="navbar-start is-align-items-center">
      @for (route of routes; track route.name) {
        @if (!route.role || hasRole(route.role)) {
          <a
            class="navbar-item is-rounded is-primary"
            [attr.data-testid]="route.name"
            [routerLink]="route.url"
            routerLinkActive="active-link"
          >
            {{ 'navbar.' + route.name | translate }}
          </a>
        }
      }
    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          <a
            class="button is-light"
            (click)="logout()"
            translate="navbar.logout"
          ></a>
        </div>
      </div>
    </div>
  </div>
</nav>
